(function () {
  function formatCents(el) {
    if (el.dataset.centsFormatted) return;
    const text = el.textContent.trim();
    // Match decimal separator (comma or period) followed by exactly 2 digits, then optional suffix
    const m = text.match(/^([\s\S]*\d)([,\.])(\d{2})([\s\S]*)$/);
    if (!m) return;
    el.dataset.centsFormatted = '1';
    el.textContent = '';
    const main = document.createElement('span');
    main.className = 'price-int';
    main.textContent = m[1];
    el.appendChild(main);
    const cents = document.createElement('span');
    cents.className = 'price-cents';
    cents.textContent = m[2] + m[3];
    el.appendChild(cents);
    if (m[4].trim()) el.appendChild(document.createTextNode(m[4]));
  }

  function run() {
    document.querySelectorAll('.price-item').forEach(function (el) {
      if (!el.dataset.centsFormatted) formatCents(el);
    });
  }

  // Rescrie prețul dintr-un `.price-item` și reface separarea leilor de bani.
  // Folosit de aperte-card-swatches.js când clientul alege altă culoare, la
  // produsele unde variantele au prețuri diferite.
  window.aperteSetPrice = function (el, text) {
    if (!el) return;
    delete el.dataset.centsFormatted;
    el.textContent = text;
    formatCents(el);
  };

  document.addEventListener('DOMContentLoaded', run);

  // Re-process newly added price elements (variant changes, cart updates)
  const mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('price-item')) {
          formatCents(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.price-item').forEach(formatCents);
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
